import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
import classnames from 'classnames';
import { Button, Close, Palette } from '@sbt-web/ui';
import classes from './styles.module.scss';
interface Props {
  show?: boolean;
  onClose: () => void;
  onNotifyMe: () => void;
}
const SnackBarContent: FC<Props> = t0 => {
  const $ = _c(18);
  const {
    show: t1,
    onClose,
    onNotifyMe
  } = t0;
  const show = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== show) {
    t2 = classnames(classes["snackbar-wrapper"], {
      [classes["wrapper-visible"]]: show
    });
    $[0] = show;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = classnames("body-text", "small", classes.invitation);
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <p className={t3}>Scopri quando vengono pubblicati <b>nuovi annunci</b></p>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = [classes["notify-me"]];
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <img src="/static/img/ui/bell-small-off.svg" height="16" width="16" alt="" loading="lazy" decoding="async" />;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== onNotifyMe) {
    t7 = <Button classes={t5} size="small" onClick={onNotifyMe} iconLeft={t6}>Avvisami</Button>;
    $[6] = onNotifyMe;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = [classes["snackbar-close"]];
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Close width={22} height={22} fillColor={Palette.NeutralGrey2} />;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== onClose) {
    t10 = <Button classes={t8} design="text" onClick={onClose} icon={t9} />;
    $[10] = onClose;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== t10 || $[13] !== t7) {
    t11 = <div className={classes.snackbar}>{t4}{t7}{t10}</div>;
    $[12] = t10;
    $[13] = t7;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== t11 || $[16] !== t2) {
    t12 = <div className={t2}>{t11}</div>;
    $[15] = t11;
    $[16] = t2;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  return t12;
};
SnackBarContent.displayName = 'SnackBarContent';
export default SnackBarContent;